import { render, staticRenderFns } from "./OverseaTip.vue?vue&type=template&id=5a4e3303&scoped=true&"
import script from "./OverseaTip.vue?vue&type=script&lang=js&"
export * from "./OverseaTip.vue?vue&type=script&lang=js&"
import style0 from "./OverseaTip.vue?vue&type=style&index=0&id=5a4e3303&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e3303",
  null
  
)

export default component.exports